import { links } from "./links";
import ErrorPage from "./pages/error-page";

export default [
  {
    routeProps: {
      path: links.error,
      exact: true,
      component: ErrorPage,
    },
    name: "error",
  },
];
